export default "__VITE_ASSET__Cq8kHx3k__"